import React, { useState } from "react";
import "../scss/index.scss";
import Sidebar from "../components/sidebar/Sidebar";
import DarkLightButton from "../components/DarkLightButton";
import { Outlet } from "react-router-dom";
const Layout = () => {
  const [open, setOpen] = useState(false);
  return (
    <div className="layout">
      <div className="container">
        <div className="sidebar " style={{ left: open ? "0" : "-100%" }}>
          <Sidebar setOpen={setOpen} />
          <span className="close icon-btn" onClick={() => setOpen(false)}>
            <i class="fa-solid fa-xmark"></i>
          </span>
        </div>
        <div className="topbar">
          <span className="menu icon-btn " onClick={() => setOpen(true)}>
            <i class="fa-solid fa-bars"></i>
          </span>
          <span className="mode">
            <DarkLightButton />
          </span>
        </div>
        <span className="mode-change">
          <DarkLightButton />
        </span>
        <div className="main-page">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Layout;
